<template><WithLoader :isLoading="true"></WithLoader></template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

import WithLoader from "@/components/WithLoader";
import withToasted from "@/mixins/withToasted";
import withNavigate from "@/mixins/withNavigate";
import { mapActions } from "vuex";

export default Vue.component("InvitationSetup", {
  components: {
    WithLoader
  },

  mixins: [withNavigate, withToasted],

  methods: {
    errorsValidation(e) {
      if (e.status === 500) {
        return this.errorToast(
          "Something went wrong. Please, contact support@inkit.com"
        );
      }
    },

    ...mapActions("auth", ["login"]),
    ...mapActions("account", ["fetchIdentity"])
  },

  created() {
    const { token, email } = this.$route.query;

    if (!token || !email) {
      this.toast(
        "Token or email is missing. You will be redirected in 3 seconds.",
        "error",
        { duration: 3000 }
      );

      setTimeout(() => {
        this.navigate("/link-expired");
      }, 2000);
    } else {
      this.login({
        data: { email, password: token },
        onSuccess: response => {
          this.fetchIdentity({
            onSuccess: () =>
              this.navigate({
                name: "sign-up"
              })
          });
        },
        onError: e =>
          this.errorsValidation(e) /*this.navigate("/link-expired")*/
      });
    }
  }
});
</script>

<style lang="scss" scoped></style>
